import { SvgIcon, ToggleButton, ToggleButtonGroup, Tooltip } from '@chronosphereio/chrono-ui';
import { Grid as GridIcon, ViewListOutline as ViewListOutlineIcon } from 'mdi-material-ui';
import { LegendMode } from '@/core';
import { ContentWithLegendToggleModeProps } from './model/content-with-legend-model';

type ToggleButtonConfig = {
  value: LegendMode;
  IconComponent: typeof SvgIcon;
};

const toggleButtonValues: ToggleButtonConfig[] = [
  { value: 'List', IconComponent: ViewListOutlineIcon },
  { value: 'Table', IconComponent: GridIcon },
];

export function ContentWithLegendToggleMode({ show, mode, onChange }: ContentWithLegendToggleModeProps) {
  if (!show) {
    return null;
  }

  return (
    <ToggleButtonGroup
      onChange={(e, value) => {
        if (value) {
          onChange?.(value);
        }
      }}
      value={mode}
    >
      {toggleButtonValues.map(({ value, IconComponent }) => {
        const buttonLabel = `${value} view`;

        return (
          <ToggleButton key={value} value={value} aria-label={buttonLabel}>
            <Tooltip Content={buttonLabel}>
              <IconComponent
                sx={{
                  color: (theme) => (theme.featureFlags.panwRebrandStubYear ? undefined : theme.palette.grey[800]),
                }}
              />
            </Tooltip>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}
